(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mj-header"]) return;
  try {
    
  // Sticky header "stick_on_scroll" : même logique que le header natif Avante, sur #shopify-section-mj-header.
  class MJStickyHeader extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section');
      this.mode = this.getAttribute('data-sticky');
      if (!this.section || this.mode !== 'stick_on_scroll') return;
      this.current = 0; this.state = 'reset'; this.raf = 0;
      this.onScroll = this.onScroll.bind(this);
      this.measure = this.measure.bind(this);
      this.measure();
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.measure, { passive: true });
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.measure);
    }
    measure() {
      const h = Math.ceil(this.section.getBoundingClientRect().height || 0);
      document.documentElement.style.setProperty('--header-height', h + 'px');
      const top = window.pageYOffset || 0;
      const r = this.getBoundingClientRect();
      this.bounds = { top: r.top + top, bottom: r.bottom + top };
    }
    onScroll() {
      if (this.raf) return;
      this.raf = requestAnimationFrame(() => {
        this.raf = 0;
        const y = window.pageYOffset || 0;
        const past = y > this.bounds.bottom + 4;
        const before = y <= this.bounds.top + 4;
        if (this.classList.contains('is-open')) { this.current = y; return; }
        if (y > this.current && past) this.set('hidden');
        else if (y < this.current && past) this.set('revealed');
        else if (before) this.set('reset');
        this.current = y;
      });
    }
    set(next) {
      if (this.state === next) return;
      this.state = next;
      const c = this.section.classList;
      if (next === 'hidden') { c.add('shopify-section-header-hidden', 'shopify-section-header-sticky'); c.remove('animate'); }
      else if (next === 'revealed') { c.add('shopify-section-header-sticky', 'animate'); c.remove('shopify-section-header-hidden'); }
      else { c.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate'); }
    }
  }
  if (!customElements.get('mj-sticky-header')) customElements.define('mj-sticky-header', MJStickyHeader);

  class MJMobileStickyHeader extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section');
      if (!this.section || this.getAttribute('data-sticky') !== 'stick_on_scroll') return;
      this.current = 0; this.state = 'reset'; this.raf = 0;
      this.onScroll = this.onScroll.bind(this);
      this.measure = this.measure.bind(this);
      this.measure();
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.measure, { passive: true });
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.measure);
    }
    measure() {
      const top = window.pageYOffset || 0;
      const r = this.getBoundingClientRect();
      this.bounds = { top: r.top + top, bottom: r.bottom + top };
    }
    onScroll() {
      if (this.raf) return;
      this.raf = requestAnimationFrame(() => {
        this.raf = 0;
        const y = window.pageYOffset || 0;
        const past = y > this.bounds.bottom + 4;
        if (y > this.current && past) this.set('hidden');
        else if (y < this.current && past) this.set('revealed');
        else if (y <= this.bounds.top + 4) this.set('reset');
        this.current = y;
      });
    }
    set(next) {
      if (this.state === next) return;
      this.state = next;
      const c = this.section.classList;
      if (next === 'hidden') { c.add('shopify-section-mobile-header-hidden', 'shopify-section-mobile-header-sticky'); c.remove('animate'); }
      else if (next === 'revealed') { c.add('shopify-section-mobile-header-sticky', 'animate'); c.remove('shopify-section-mobile-header-hidden'); }
      else { c.remove('shopify-section-mobile-header-hidden', 'shopify-section-mobile-header-sticky', 'animate'); }
    }
  }
  if (!customElements.get('mj-mobile-sticky-header')) customElements.define('mj-mobile-sticky-header', MJMobileStickyHeader);

  class MJMenuDrawer extends HTMLElement {
    connectedCallback() {
      if (this._mjInit) return;
      this._mjInit = true;
      // Sorti du wrapper de section (sticky/transform) pour rester en position: fixed plein écran
      this.sectionEl = this.closest('.shopify-section');
      if (this.sectionEl && this.parentElement !== document.body) {
        document.body.appendChild(this);
        document.addEventListener('shopify:section:unload', (e) => { if (e.target === this.sectionEl) this.remove(); });
      }
      this.overlay = null;
      this.openers = Array.from(document.querySelectorAll('[data-mj-drawer-open]'));
      this.closers = Array.from(this.querySelectorAll('[data-mj-drawer-close]'));
      this.lastFocus = null;

      this.open = this.open.bind(this);
      this.close = this.close.bind(this);

      this.openers.forEach(b => b.addEventListener('click', this.open));
      this.closers.forEach(b => b.addEventListener('click', this.close));
      if (this.overlay) this.overlay.addEventListener('click', this.close);
      document.addEventListener('keydown', e => { if (e.key === 'Escape' && this.classList.contains('is-open')) this.close(); });
      document.addEventListener('cart-drawer:open', this.close);

      // Accordéons
      this.querySelectorAll('[data-mj-acc]').forEach(item => {
        const head = item.querySelector('[aria-expanded]');
        if (!head) return;
        head.addEventListener('click', () => {
          const open = item.classList.toggle('is-open');
          head.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });

      // Éditeur de thème
      if (this.sectionEl && window.Shopify && Shopify.designMode) {
        document.addEventListener('shopify:block:select', (e) => { if (this.contains(e.target) || this.querySelector('[data-mj-review]')) { if (e.target.closest && e.target.closest('[data-mj-review]')) this.open(); } });
        document.addEventListener('shopify:block:deselect', (e) => { if (e.target.closest && e.target.closest('[data-mj-review]')) this.close(); });
      }
    }
    open() {
      this.lastFocus = document.activeElement;
      this.classList.add('is-open');
      if (this.overlay) this.overlay.classList.add('is-open');
      document.body.classList.add('hidden', 'mj-drawer-open');
      this.openers.forEach(b => b.setAttribute('aria-expanded', 'true'));
      setTimeout(() => { const f = this.querySelector('[data-mj-drawer-close]'); if (f) f.focus(); }, 60);
    }
    close() {
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      if (this.overlay) this.overlay.classList.remove('is-open');
      document.body.classList.remove('hidden', 'mj-drawer-open');
      this.openers.forEach(b => b.setAttribute('aria-expanded', 'false'));
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    }
  }
  if (!customElements.get('mj-menu-drawer')) customElements.define('mj-menu-drawer', MJMenuDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["secondary-header"]) return;
  try {
    
class StickySecondaryHeader extends HTMLElement {
  constructor() {
    super();

    this.header = null;
    this.headerSection = null;
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.preventHide = false;
    this.isScrolling = null;
    this.predictiveSearch = null;
    this._rafScroll = 0;
    this._pendingScrollTop = 0;

    this._state = 'reset';
    this.headerBounds = { top: 0, bottom: 0 };
    this.THRESHOLD_EPS = 4;

    this._started = false;
    this.onScroll = this.onScroll.bind(this);
    this._runScroll = this._runScroll.bind(this);
    this._measure = this._measure.bind(this);
    this._start = this._start.bind(this);

    this.hideHeaderOnScrollUp = () => { this.preventReveal = true; };

    this._wakeOnScroll = this._wakeOnScroll.bind(this);
    this._wakeOnPointer = this._wakeOnPointer.bind(this);
    this._wakeOnKey = this._wakeOnKey.bind(this);
  }

  connectedCallback() {
    window.addEventListener('scroll', this._wakeOnScroll, { passive: true, once: true });
    window.addEventListener('pointerdown', this._wakeOnPointer, { passive: true, once: true });
    window.addEventListener('touchstart', this._wakeOnPointer, { passive: true, once: true });
    window.addEventListener('keydown', this._wakeOnKey, { passive: true, once: true });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this._wakeOnScroll);
    window.removeEventListener('pointerdown', this._wakeOnPointer);
    window.removeEventListener('touchstart', this._wakeOnPointer);
    window.removeEventListener('keydown', this._wakeOnKey);
    window.removeEventListener('scroll', this.onScroll);

    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

    if (this._rafScroll) cancelAnimationFrame(this._rafScroll);
    this._rafScroll = 0;
  }

  _wakeOnScroll() { this._start(); }
  _wakeOnPointer() { this._start(); }
  _wakeOnKey() { this._start(); }

  _start() {
    if (this._started) return;
    this._started = true;

    window.removeEventListener('pointerdown', this._wakeOnPointer);
    window.removeEventListener('touchstart', this._wakeOnPointer);
    window.removeEventListener('keydown', this._wakeOnKey);

    this.header = document.querySelector('.shopify-section-header');
    if (!this.header) return;

    this.headerSection = this.header.querySelector('.header-section') || this.header;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    this._measure();

    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.onScroll();
  }

  _measure() {
    if (!this.header) return;

    const h = Math.ceil(this.header.getBoundingClientRect().height || 0);
    const next = `${h}px`;
    const prev = document.documentElement.style.getPropertyValue('--header-height');
    if (prev !== next) {
      document.documentElement.style.setProperty('--header-height', next);
    }

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    const rect = this.headerSection.getBoundingClientRect();
    this.headerBounds = { top: rect.top + scrollTop, bottom: rect.bottom + scrollTop };
  }

  onScroll() {
    this._pendingScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    if (this._rafScroll) return;
    this._rafScroll = requestAnimationFrame(this._runScroll);
  }

  _runScroll() {
    this._rafScroll = 0;

    const scrollTop = this._pendingScrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) {
      this.currentScrollTop = scrollTop;
      return;
    }

    const hb = this.headerBounds;
    const eps = this.THRESHOLD_EPS;

    const pastBottom = scrollTop > (hb.bottom + eps);
    const beforeTop  = scrollTop <= (hb.top + eps);

    if (scrollTop > this.currentScrollTop && pastBottom) {
      if (!this.preventHide) this._setState('hidden');
    } else if (scrollTop < this.currentScrollTop && pastBottom) {
      if (!this.preventReveal) {
        this._setState('revealed');
      } else {
        clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
        this._setState('hidden');
      }
    } else if (beforeTop) {
      this._setState('reset');
    }

    this.currentScrollTop = scrollTop;
  }

  _setState(next) {
    if (!this.header || this._state === next) return;
    this._state = next;

    if (next === 'hidden') {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.header.classList.remove('animate');
      return;
    }

    if (next === 'revealed') {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      return;
    }

    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }
}

customElements.define('sticky-secondary-header', StickySecondaryHeader);

  } catch(e) { console.error(e); }
})();
})();
